var isKind = require('./isKind');
    /**
     */
    function isDate(val) {
        return isKind(val, 'Date');
    }
    module.exports = isDate;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isDate.js
// module id = 267
// module chunks = 0 1 2